import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { showNotification, showCustomNotification } from 'shared/ui/Notification';
import type { InternalApiRequestError } from 'shared/hooks/useInternalApiRequest/types';
import {
  SUBSCRIPTION_API_ERRORS_DETAILS,
  type SubscriptionApiErrorDetails
} from 'shared/constants/subscriptionApiErrors';

export function useSubscriptionApiErrorToast() {
  const { t } = useTranslation('subscriptionApiErrorMessages');

  return useCallback(
    (error: InternalApiRequestError) => {
      const errorCode = error?.data?.error_code;
      let subscriptionApiError: SubscriptionApiErrorDetails | undefined;

      if (errorCode) {
        subscriptionApiError = SUBSCRIPTION_API_ERRORS_DETAILS[errorCode];

        if (subscriptionApiError) {
          showCustomNotification({
            props: {
              title: t(subscriptionApiError.translationKey)
            },
            type: subscriptionApiError.type
          });
        }
      }

      if (!subscriptionApiError) {
        showNotification('mutationError');
      }
    },
    [t]
  );
}
